"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = require("@material-ui/core/styles");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _useMediaQuery = _interopRequireDefault(require("@material-ui/core/useMediaQuery"));
var _styles2 = require("../utilities/styles");
var _button = _interopRequireDefault(require("../button"));
var _excluded = ["classes", "FontAwesomeIconProps"];
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var useClasses = (0, _styles.makeStyles)(function (_ref) {
  var highContrast = _ref.accessibility.highContrast;
  return {
    root: (0, _defineProperty2.default)({
      '&:hover svg path': {
        fill: function fill(_ref2) {
          var fillId = _ref2.fillId,
            isHighContrast = _ref2.isHighContrast;
          return !!isHighContrast ? 'WindowText' : "url(#".concat(fillId, ")");
        }
      }
    }, highContrast.mediaQuery('active'), {
      color: 'WindowText'
    }),
    focus: {
      '&:focus svg path': {
        fill: function fill(_ref3) {
          var fillId = _ref3.fillId,
            isHighContrast = _ref3.isHighContrast;
          return !!isHighContrast ? 'WindowText' : "url(#".concat(fillId, ")");
        }
      }
    }
  };
});
var Instagram = function Instagram(_ref4) {
  var classes = _ref4.classes,
    FontAwesomeIconProps = _ref4.FontAwesomeIconProps,
    rest = (0, _objectWithoutProperties2.default)(_ref4, _excluded);
  var _useState = (0, _react.useState)(),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    fillId = _useState2[0],
    setFillId = _useState2[1];
  var currentTheme = (0, _styles.useTheme)();
  var isHighContrast = (0, _useMediaQuery.default)(currentTheme.accessibility.highContrast.mediaQuery('active'));
  var _classes = useClasses({
    fillId: fillId,
    isHighContrast: isHighContrast
  });
  (0, _react.useEffect)(function () {
    setFillId("instagram-gradient-".concat(new Date().getTime()));
  }, []);
  return /*#__PURE__*/_react.default.createElement(_button.default, (0, _extends2.default)({
    title: "Instagram",
    "aria-label": "Instagram"
  }, rest, {
    classes: (0, _styles2.mergeClasses)({
      root: _classes.root,
      focusVisible: _classes.focus
    }, classes)
  }), !isHighContrast && /*#__PURE__*/_react.default.createElement("svg", {
    width: "0",
    height: "0"
  }, /*#__PURE__*/_react.default.createElement("radialGradient", {
    id: fillId,
    r: "150%",
    cx: "30%",
    cy: "107%"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    stopColor: "#fdf497",
    offset: "0"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    stopColor: "#fdf497",
    offset: "0.05"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    stopColor: "#fd5949",
    offset: "0.45"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    stopColor: "#d6249f",
    offset: "0.6"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    stopColor: "#285AEB",
    offset: "0.9"
  }))), /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, (0, _extends2.default)({
    icon: ['fab', 'instagram'],
    size: "2x",
    fixedWidth: true
  }, FontAwesomeIconProps)));
};
Instagram.propTypes = {
  classes: _propTypes.default.object,
  FontAwesomeIconProps: _propTypes.default.object
};
Instagram.defaultProps = {
  classes: null,
  FontAwesomeIconProps: {}
};
var _default = Instagram;
exports.default = _default;